import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { UiModule } from '@eg/ui';
import { SharedPipesModule } from '@railmybox/shared/pipes';
import { TrainCardContainersComponent } from './train-card-containers.component';
import { CapacityPillModule } from '../capacity-pill';
import { BookingServicesModule } from '../booking-services';

@NgModule({
  declarations: [TrainCardContainersComponent],
  imports: [CommonModule, TranslocoModule, UiModule, SharedPipesModule, FlexLayoutModule, CapacityPillModule, BookingServicesModule],
  exports: [TrainCardContainersComponent],
})
export class TrainCardContainersModule {}
